<div class="space-y-3">
	<app-input-reusable
		class="question-input"
		[label]="questionLabel"
		[required]="required"
		[control]="questionControl"
		[readonly]="questionReadonly"
		size="md"
	></app-input-reusable>

	<app-input-reusable
		[label]="commentLabel"
		type="textarea"
		size="md"
		[placeholder]="commentPlaceholder || ''"
		[control]="commentControl"
	></app-input-reusable>

	<p *ngIf="maxCommentLength" class="text-xs text-slate400 text-right">
		{{ commentCount }} / {{ maxCommentLength }}
	</p>
</div>
